/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GenericErrorResponse,
  PreviewReportExchangeResponse,
  ReportFieldsResponse,
  ReportQueryResponse,
  SharedReportExchangeResponse,
  SharedReportLinkResponse,
} from './responses';

import { ReportQueryRequest } from './requests';


import { ContentType, HttpClient, RequestParams } from './httpClient';

export class Reports<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags App
   * @name getSharedReportLink
   * @param {string} reportId The ID of the report to retrieve.
   * @request POST:/reports/shared/{reportId}
   * @response `200` `SharedReportLinkResponse` Success
   */
  getSharedReportLink = (reportId: string, formData: Record<string, string | number | boolean> | null, params: RequestParams = {}) =>
    this.request<SharedReportLinkResponse, GenericErrorResponse>({
      path: `/reports/share/${reportId}`,
      method: 'POST',
      format: 'json',
      secure: true,
      type: ContentType.Json,
      body: formData,
      ...params,
    });
  
  exchangeSharedReportToken = (reportId: string, token: string, params: RequestParams = {}) =>
    this.request<SharedReportExchangeResponse, GenericErrorResponse>({
      path: `/reports/exchange/${reportId}/${token}`,
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });

  /**
   * Exchanges a preview fragment token for a JWT scoped to one report + revision.
   * Unauthenticated, and the report id is not part of the path.
   *
   * @name exchangePreviewToken
   * @request GET:/reports/preview/{token}
   * @response `200` `PreviewReportExchangeResponse` Success
   * @response `400` `GenericErrorResponse` code 33010 — link expired or never existed
   */
  exchangePreviewToken = (token: string, params: RequestParams = {}) =>
    this.request<PreviewReportExchangeResponse, GenericErrorResponse>({
      path: `/reports/preview/${token}`,
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });

  getReportFields = (adapter: string, params: RequestParams = {}) =>
    this.request<ReportFieldsResponse, GenericErrorResponse>({
      path: `/reports/fields/${encodeURIComponent(adapter)}`,
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });

  queryReport = (body: ReportQueryRequest, params: RequestParams = {}) =>
    this.request<ReportQueryResponse, GenericErrorResponse>({
      path: '/reports/query',
      method: 'POST',
      format: 'json',
      secure: true,
      type: ContentType.Json,
      body,
      ...params,
    });
}
